// remove  site-main-contents class from main tag to solve the header overlapping  issue when home page banner no added
document.addEventListener("DOMContentLoaded", function () {
    const sectionElements = document.querySelectorAll(".section");
    const parentElement = document.querySelector('.site-main');

    // Check if parentElement exists
    if (parentElement) {
        sectionElements.forEach(section => {
            if (section.classList.contains('section-banner')) {
                parentElement.classList.remove('site-main--contents');
            }
        });
    }

});